module.exports = __webpack_public_path__ + "img/opalToothpaste-option.eb9aff02.png";